import type { AriaCheckboxProps } from '@react-types/checkbox';
import type { VariantProps } from 'tailwind-variants';
import { useMemo } from 'react';

import { useToggleState } from '@react-stately/toggle';

import type { DefaultComponentProps } from '../../types';
import { checkboxVariants } from '../Checkbox';
import { CheckboxIcon } from '../Checkbox/CheckboxIcon';

export type CheckIconProps = DefaultComponentProps<{
  defaultComponent: 'div';
  props: AriaCheckboxProps & VariantProps<typeof checkboxVariants>;
}>;

/**
 * @private
 * @param props
 * @returns
 */
export const CheckIcon = (props: CheckIconProps) => {
  const { className, size = 'md' } = props;

  const state = useToggleState(props);
  const { isSelected } = state;

  const styles = useMemo(
    () =>
      checkboxVariants({
        size,
      }),
    [size],
  );

  return (
    <div
      className={styles.base({ className })}
      data-selected={isSelected}
    >
      <span className={styles.iconWrapper()}>
        <CheckboxIcon
          className={styles.icon()}
          isSelected={isSelected}
        />
      </span>
    </div>
  );
};
